/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown> }} Plan_Tab_Downgrade_ConfirmInputs */



/**
* | output |
* | --- |
* | "Downgrade to {plan}" |
*
* @param {Plan_Tab_Downgrade_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_downgrade_confirm = /** @type {((inputs: Plan_Tab_Downgrade_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Downgrade_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Auf ${i?.plan} downgraden`)
	return /** @type {LocalizedString} */ (`Downgrade to ${i?.plan}`)
});